/**
 * Do not edit this file it is auto-generated by io-utils / gen-api-models.
 * See https://github.com/pagopa/io-utils
 */
/* eslint-disable  */

import { CounterpartTable } from "./CounterpartTable";
import { PageInfo } from "./PageInfo";
import * as t from "io-ts";

// required attributes
const CounterpartTablesR = t.interface({
  counterpart_tables: t.readonlyArray(
    CounterpartTable,
    "array of CounterpartTable"
  ),

  page_info: PageInfo
});

// optional attributes
const CounterpartTablesO = t.partial({});

export const CounterpartTables = t.intersection(
  [CounterpartTablesR, CounterpartTablesO],
  "CounterpartTables"
);

export type CounterpartTables = t.TypeOf<typeof CounterpartTables>;
